export default "__VITE_ASSET__BhCYLO4L__"